import { format } from 'date-fns';
import { Spinner, Center } from '@chakra-ui/react';

export const formatDate = (dateString) => format(new Date(dateString), 'MMMM d, yyyy');

export const LoadingSpinner = () => (
    <Center h="100vh"> {/* Full screen centering */}
        <Spinner size="xl" color="teal.500" /> {/* Customize the spinner */}
    </Center>
);